(() => {
  const init = (root) => {
    if (root.dataset.tabletDirectoryReady === 'true') return;
    root.dataset.tabletDirectoryReady = 'true';

    const filters = Array.from(root.querySelectorAll('[data-tablet-filter]'));
    const items = Array.from(root.querySelectorAll('[data-tablet-item]'));
    const heading = root.querySelector('[data-tablet-results-heading]');
    const status = root.querySelector('[data-tablet-results-status]');
    const searchForm = root.querySelector('[data-tablet-search-form]');
    const searchInput = root.querySelector('[data-tablet-search]');
    const clearButton = root.querySelector('[data-tablet-search-clear]');
    const noResults = root.querySelector('[data-tablet-no-results]');

    if (!filters.length || !items.length) return;

    let activeType = 'all';
    let activeLabel = 'All';

    const normalize = (value) => String(value || '').trim().toLowerCase();

    const applyFilters = () => {
      const query = normalize(searchInput?.value);
      const allowedTypes = activeType === 'all' ? [] : activeType.split(',');
      let visible = 0;

      items.forEach((item) => {
        const card = item.querySelector('[data-search]');
        const searchableText = normalize(`${card?.dataset.search || ''} ${item.dataset.tabletType || ''}`);
        const matchesType = activeType === 'all' || allowedTypes.includes(item.dataset.tabletType);
        const matchesSearch = !query || searchableText.includes(query);
        const show = matchesType && matchesSearch;

        item.hidden = !show;
        if (show) visible += 1;
      });

      filters.forEach((button) => {
        const active = button.dataset.tabletFilter === activeType;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      if (heading) {
        heading.textContent = activeType === 'all' ? 'All Tablet Skins & Accessories' : activeLabel;
      }
      if (status) {
        const searchStatus = query ? ` matching “${searchInput.value.trim()}”` : '';
        status.textContent = `${visible} ${visible === 1 ? 'item' : 'items'}${searchStatus}, newest first`;
      }
      if (clearButton) clearButton.hidden = !query;
      if (noResults) noResults.hidden = visible !== 0;
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        activeType = button.dataset.tabletFilter || 'all';
        activeLabel = button.dataset.label || 'All';
        applyFilters();
      });
    });

    searchForm?.addEventListener('submit', (event) => event.preventDefault());
    searchInput?.addEventListener('input', applyFilters);
    clearButton?.addEventListener('click', () => {
      searchInput.value = '';
      applyFilters();
      searchInput.focus();
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-sw-tablet-directory]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
